var AppConstants = require('../constants/AppConstants');
var AppDispatcher = require('../dispatcher/AppDispatcher');
var Utils = require('../utils/Utils');
var UrlUtils = require('../utils/urlUtils');
var LoginHelper = require('../utils/loginHelper');
var assign = require('object-assign');
var Store = require('./Store');
var _ = require('lodash');
var ErrorCodes = require('../utils/ErrorCodes');
var base64url = require('base64url');
const { setCodesViaSmsTOTPValidityTimestamp, removeCodesViaSmsTOTPValidityTimestamp } = require('../utils/Utils');
const $ = require('jquery');

const LOGIN_CHANGE_EVENT = 'login_change';
const LOGIN_WITH_PASSCODE_EVENT = 'login_with_passcode_change';
const SAML_LOGIN_CHANGE_EVENT = 'saml_login_change';
const TOTP_CHECK_EVENT = 'totp_check';
const TOTP_RESENT_EVENT = 'totp_resent';
const OTP_SENT_VIA_SMS_EVENT = 'otp_sent_via_sms';
const FORGOT_PASSWORD_CHANGE_EVENT = 'ForgotPassword_change';
const CHANGE_PASSWORD_CHANGE_EVENT = 'ChangePassword_change';
const RESET_PASSWORD_CHANGE_EVENT = 'ResetPassword_change';
const TOAST_CHANGE_EVENT = 'toast_change';
const TRANSLATIONS_RECEIVED = 'translations_received';
const SUPPORTED_LOCALES_RECEIVED = 'supported_locales_received';
const USER_LOGIN_STRATEGY_RECEIVED = 'user_strategy';
const ALLOW_X_509_LOGIN_RECEIVED = 'allow_x_509_login_received';
const GET_TWO_FA_TEMP_SECRET = 'get_two_fa_temp_secret';
const VALIDATE_2FA_TOTP_APP = 'validate_2fa_totp_app';
const SAVE_2FA_WEB_AUTHN = 'save_2fa_web_authn';
const USER_WEBAUTHN_CREDENTIALS = 'user_webauthn_credentials';
const USER_CREDENTIALS_CAPTURE = 'user_credentials_capture';
const USER_CREDENTIALS_CREATED = 'user_credentials_created';
const USER_CREDENTIALS_DELETED = 'user_credentials_deleted';
const GET_USER_DETAILS = 'get_user_details';
const GET_MFA_OPTIONS = "get_mfa_options"
const GET_USER_MFA_OPTIONS = 'get_user_mfa_options';
const GET_PASSWORDLESS_METHODS = 'get_passwordless_methods';
const GET_PASSWORDLESS_INFO = 'get_passwordless_info';
const SET_IS_INTRANET_REQUESTV2 = 'set_is_intranet_requestv2';
const VALIDATE_OTP_AUTH = 'validate_otp_auth';
const GENERATE_OTP_CODE = 'generate_otp_code';
const CHANGE_USER_MFA_METHOD = 'change_user_mfa_method';
const DELETE_USER_MFA_METHOD = 'delete_user_mfa_method';
const LINK_HD_ACCOUNT = 'link_hd_account';
const CONSENT_HD = 'consent_hd';

var ActionTypes = AppConstants.ActionTypes;

var appState = {
    IsIntranetRequestV2: false
};

var defaultWebPageConfiguations = {
    "generalConfigurations": {
        "items": [
            {
                "key": "showLoginAsCustomerLink",
                "value": "false"
            },
            {
                "key": "showLoginAsEmployeeLinkInInternet",
                "value": "false"
            }
        ]
    },
    "footerLinks": {
        "items": []
    },
    "CustomerComponentLinks": {
        "items": [
            {
                "key": "newCustomerSignUpButton",
                "value": ""
            },
            {
                "key": "createLogin",
                "value": ""
            },
            {
                "key": "signUpLink",
                "value": ""
            }
        ]
    },
    "employeeLogin": {
        "items": [
            {
                "key": "employeeLoginRequiresOTP",
                "value": "false"
            },
            {
                "key": "customizeForgotPwdLink",
                "value": "true"
            },
            {
                "key": "forgotPwdLinkUrl",
                "value": "https://identity.metro.info/forgot-password"
            }
        ]
    },
    "customerLogin": {
        "items": [
            {
                "key": "customizeForgotPwdLink",
                "value": "false"
            },
            {
                "key": "forgotPwdLinkUrl",
                "value": ""
            }
        ]
    },
    "supplierLogin": {
        "items": [
            {
                "key": "customizeForgotPwdLink",
                "value": "false"
            },
            {
                "key": "forgotPwdLinkUrl",
                "value": ""
            }
        ]
    },
    "developerLogin": {
        "items": [
            {
                "key": "customizeForgotPwdLink",
                "value": "false"
            },
            {
                "key": "forgotPwdLinkUrl",
                "value": ""
            }
        ]
    }
};

var LoginStore = assign(new Store(), {
    getState: function () {
        return appState;
    },
    emitLoginChange: function () {
        this.emit(LOGIN_CHANGE_EVENT);
    },
    emitLoginWithPasscodeChange: function () {
        this.emit(LOGIN_WITH_PASSCODE_EVENT);
    },
    emitSamlLoginChange: function () {
        this.emit(SAML_LOGIN_CHANGE_EVENT);
    },
    addLoginChangeListener: function (callback) {
        this.on(LOGIN_CHANGE_EVENT, callback);
    },
    addLoginWithPasscodeListener: function (callback) {
        this.on(LOGIN_WITH_PASSCODE_EVENT, callback);
    },
    addSamlLoginChangeListener: function (callback) {
        this.on(SAML_LOGIN_CHANGE_EVENT, callback);
    },

    emitTotpValidation: function () {
        this.emit(TOTP_CHECK_EVENT);
    },

    totpValidationListner: function (callback) {
        this.on(TOTP_CHECK_EVENT, callback);
    },

    emitTotpResent: function () {
        this.emit(TOTP_RESENT_EVENT);
    },

    emitOtpSentViaSms: function () {
        this.emit(OTP_SENT_VIA_SMS_EVENT)
    },

    otpSentViaSmsListener: function (callback) {
        this.on(OTP_SENT_VIA_SMS_EVENT, callback);
    },

    removeOtpSentViaSmsListener: function (callback) {
        this.removeListener(OTP_SENT_VIA_SMS_EVENT, callback);
    },

    totpResentListner: function (callback) {
        this.on(TOTP_RESENT_EVENT, callback);
    },

    removeLoginChangeListener: function (callback) {
        this.removeListener(LOGIN_CHANGE_EVENT, callback);
    },

    removeSamlLoginChangeListener: function (callback) {
        this.removeListener(SAML_LOGIN_CHANGE_EVENT, callback);
    },

    removeLoginWithPasscodeListener: function (callback) {
        this.removeListener(LOGIN_WITH_PASSCODE_EVENT, callback);
    },

    emitForgotPasswordChange: function () {
        this.emit(FORGOT_PASSWORD_CHANGE_EVENT);
    },

    addForgotPasswordChangeListener: function (callback) {
        this.on(FORGOT_PASSWORD_CHANGE_EVENT, callback);
    },

    removeForgotPasswordChangeListener: function (callback) {
        this.removeListener(FORGOT_PASSWORD_CHANGE_EVENT, callback);
    },
    emitChangePasswordChange: function () {
        this.emit(CHANGE_PASSWORD_CHANGE_EVENT);
    },

    addChangePasswordChangeListener: function (callback) {
        this.on(CHANGE_PASSWORD_CHANGE_EVENT, callback);
    },

    removeChangePasswordChangeListener: function (callback) {
        this.removeListener(CHANGE_PASSWORD_CHANGE_EVENT, callback);
    },
    emitResetPasswordChange: function () {
        this.emit(RESET_PASSWORD_CHANGE_EVENT);
    },

    addResetPasswordChangeListener: function (callback) {
        this.on(RESET_PASSWORD_CHANGE_EVENT, callback);
    },

    removeResetPasswordChangeListener: function (callback) {
        this.removeListener(RESET_PASSWORD_CHANGE_EVENT, callback);
    },

    emitToastChange: function () {
        this.emit(TOAST_CHANGE_EVENT);
    },

    addToastChangeListener: function (callback) {
        this.on(TOAST_CHANGE_EVENT, callback);
    },

    removeToastChangeListener: function (callback) {
        this.removeListener(TOAST_CHANGE_EVENT, callback);
    },

    emitTranslationsReceived: function () {
        this.emit(TRANSLATIONS_RECEIVED);
    },

    addGetTranslationsChangeListner: function (callback) {
        this.on(TRANSLATIONS_RECEIVED, callback);
    },

    emitSupportedLocalesReceived: function () {
        this.emit(SUPPORTED_LOCALES_RECEIVED);
    },

    addGetSupportedLocalesListner: function (callback) {
        this.on(SUPPORTED_LOCALES_RECEIVED, callback);
    },

    emitUserLoginStartegyReceived: function () {
        this.emit(USER_LOGIN_STRATEGY_RECEIVED);
    },

    addGetUserLoginStartegyListner: function (callback) {
        this.on(USER_LOGIN_STRATEGY_RECEIVED, callback);
    },

    emitallowX509LoginReceived: function () {
        this.emit(ALLOW_X_509_LOGIN_RECEIVED)
    },

    addallowX509LoginListner: function (callback) {
        this.on(ALLOW_X_509_LOGIN_RECEIVED, callback);
    },

    emitTwoFATempSecretReceived: function () {
        this.emit(GET_TWO_FA_TEMP_SECRET);
    },

    addTwoFATempSecretReceived: function (callback) {
        this.on(GET_TWO_FA_TEMP_SECRET, callback);
    },

    emitValidateTwoFATotp: function () {
        this.emit(VALIDATE_2FA_TOTP_APP);
    },

    totpAppValidationListener: function (callback) {
        this.on(VALIDATE_2FA_TOTP_APP, callback);
    },
    removeTotpAppValidationListener: function (callback) {
        this.removeListener(VALIDATE_2FA_TOTP_APP, callback);
    },

    emitSave2FAWebAuthn: function () {
        this.emit(SAVE_2FA_WEB_AUTHN);
    },

    Save2FAWebAuthnListener: function (callback) {
        this.on(SAVE_2FA_WEB_AUTHN, callback);
    },
    removeSave2FAWebAuthnListener: function (callback) {
        this.removeListener(SAVE_2FA_WEB_AUTHN, callback);
    },

    emitWebauthnCredentials: function () {
        this.emit(USER_WEBAUTHN_CREDENTIALS);
    },

    webauthnCredentialsListener: function (callback) {
        this.on(USER_WEBAUTHN_CREDENTIALS, callback);
    },
    removeWebauthnCredentialsListener: function (callback) {
        this.removeListener(USER_WEBAUTHN_CREDENTIALS, callback);
    },
    emitUserCredentialsCapture: function () {
        this.emit(USER_CREDENTIALS_CAPTURE);
    },
    userCredentialsCaptureListener: function (callback) {
        this.on(USER_CREDENTIALS_CAPTURE, callback);
    },
    removeUserCredentialsCaptureListener: function (callback) {
        this.removeListener(USER_CREDENTIALS_CAPTURE, callback);
    },
    emitUserCredentialsCreated: function () {
        this.emit(USER_CREDENTIALS_CREATED);
    },
    userCredentialsCreatedListener: function (callback) {
        this.on(USER_CREDENTIALS_CREATED, callback);
    },
    removeUserCredentialsCreatedListener: function (callback) {
        this.removeListener(USER_CREDENTIALS_CREATED, callback);
    },

    emitWebauthnCredentialsDeleted: function () {
        this.emit(USER_CREDENTIALS_DELETED);
    },
    webauthnCredentialsDeletedListener: function (callback) {
        this.on(USER_CREDENTIALS_DELETED, callback);
    },
    removeWebauthnCredentialsDeletedListener: function (callback) {
        this.removeListener(USER_CREDENTIALS_DELETED, callback);
    },

    emitUserDetailsReceived: function () {
        this.emit(GET_USER_DETAILS);
    },

    addGetUserDetailsReceivedListener: function (callback) {
        this.on(GET_USER_DETAILS, callback);
    },

    removeGetUserDetailsReceivedListener: function (callback) {
        this.removeListener(GET_USER_DETAILS, callback);
    },

    emitGetMFAOptionsReceived: function () {
        this.emit(GET_MFA_OPTIONS);
    },

    addGetMFAOptionsListner: function (callback) {
        this.on(GET_MFA_OPTIONS, callback);
    },

    removeGetMFAOptionsListner: function (callback) {
        this.removeListener(GET_MFA_OPTIONS, callback);
    },

    emitGetUserMFAOptions: function () {
        this.emit(GET_USER_MFA_OPTIONS);
    },

    emitGetPasswordlessMethods: function () {
        this.emit(GET_PASSWORDLESS_METHODS);
    },

    emitGetPasswordlessInfo: function () {
        this.emit(GET_PASSWORDLESS_INFO);
    },

    emitSetIsIntranetRequestV2: function () {
        this.emit(SET_IS_INTRANET_REQUESTV2);
    },

    addGetPasswordlessMethodsListner: function (callback) {
        this.on(GET_PASSWORDLESS_METHODS, callback);
    },

    emitOtpValidation: function () {
        this.emit(VALIDATE_OTP_AUTH);
    },

    otpValidationListner: function (callback) {
        this.on(VALIDATE_OTP_AUTH, callback);
    },

    emitGenerateOtpCode: function () {
        this.emit(GENERATE_OTP_CODE);
    },

    generateOtpCodeListner: function (callback) {
        this.on(GENERATE_OTP_CODE, callback);
    },

    addGetUserMFAOptions: function (callback) {
        this.on(GET_USER_MFA_OPTIONS, callback);
    },

    emitChangeUserMFAMethod: function () {
        this.emit(CHANGE_USER_MFA_METHOD);
    },

    addChangeUserMFAMethodListener: function (callback) {
        this.on(CHANGE_USER_MFA_METHOD, callback)
    },

    removeChangeUserMFAMethodListener: function (callback) {
        this.removeListener(CHANGE_USER_MFA_METHOD, callback)
    },

    emitDeleteUserMFAMethod: function () {
        this.emit(DELETE_USER_MFA_METHOD)
    },

    addDeleteUserMFAMethodListener: function (callback) {
        this.on(DELETE_USER_MFA_METHOD, callback)
    },

    removeDeleteUserMFAMethodListener: function (callback) {
        this.removeListener(DELETE_USER_MFA_METHOD, callback)
    },

    emitConsetHD: function () {
        this.emit(CONSENT_HD)
    },

    addConsentHDListener: function (callback) {
        this.on(CONSENT_HD, callback)
    },

    removeConsentHDListener: function (callback) {
        this.removeListener(CONSENT_HD, callback)
    },

    emitLinkHDAccount: function () {
        this.emit(LINK_HD_ACCOUNT)
    },

    addLinkHDAccountListener: function (callback) {
        this.on(LINK_HD_ACCOUNT, callback)
    },

    removeLinkHDAccountListener: function (callback) {
        this.removeListener(LINK_HD_ACCOUNT, callback)
    },

});

LoginStore.getTwoFATempSecret = function (idToken, userType, traceId) {
    const { url, method } = jsRoutes.controllers.web.LoginPreferencesController.wrapTwoFAInfo(userType);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': idToken,
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'get',
        success: function (result, status, xhr) {
            appState.twoFATempSecretData = result.results[0];
            LoginStore.emitTwoFATempSecretReceived();
        },
        error: function (err, status) {
            console.log('Error in retrieving user temp secret');
            if (status === 401 || status === 403) {
                Utils.logoutRedirect()
            };
            appState.twoFATempSecretData = err;
            LoginStore.emitTwoFATempSecretReceived();
        }
    })
}

LoginStore.getUserDetails = function (idToken, userType, traceId) {
    const { url, method } = jsRoutes.controllers.web.LoginPreferencesController.wrapGetUserDetails(userType);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': idToken,
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'get',
        success: function (result, status, xhr) {
            if (result && result.results && result.results[0]) {
                var userDetails = result.results[0];
                appState.originalAuthenticationMethod = appState.originalAuthenticationMethod || userDetails.userLoginDetails.authenticationMethod;
                appState.userDetails = userDetails
            }
            else {
                appState.userDetails = {};
            }
            LoginStore.emitUserDetailsReceived();
        },
        failure: function (err) {
            console.log('Error in retrieving user details');
            appState.userDetails = err;
            LoginStore.emitUserDetailsReceived();
        }
    })
}

LoginStore.validateTOTPAppCode = function (idToken, userType, realmId, countryCode, traceId, code, mobileNumber) {
    const { url, method } = jsRoutes.controllers.web.LoginPreferencesController.wrapNewValidateTOTP();
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': idToken,
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: {
            code: code,
            countryCode: countryCode,
            realmId: realmId,
            userType: userType,
            mobileNumber: mobileNumber
        },
        success: function (result, status, xhr) {
            if (result.message === 'Successfully updated') {

                appState.validateTotpResponse = {
                    isValid: true,
                    mobileNumber: mobileNumber
                };
            } else {
                var responseResult = result && result.results ? result.results[0] : null;

                if (responseResult) {
                    if (responseResult[0].errorCode) {
                        appState.validateTotpResponse = {
                            errorCode: responseResult[0].errorCode,
                            placeholders: responseResult[0].placeholders,
                        };
                    }
                } else {
                    appState.validateTotpResponse = {
                        status: result.status,
                        placeholders: result.placeholders,
                    }
                }
            }
            LoginStore.emitValidateTwoFATotp();
        },
        failure: function (err) {
            appState.validateTotpResponse = err;
            LoginStore.emitValidateTwoFATotp();
        }
    })
}

LoginStore.validateAddTOTPAppCode = function (idToken, userType, realmId, countryCode, traceId, code, mobileNumber, localeId, method, name) {
    const url = "/web/validateOTPAddAuthMethod"
    $.ajax({
        url,
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${idToken}`,
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: {
            code: code,
            countryCode: countryCode,
            realmId: realmId,
            userType: userType,
            mobileNumber: mobileNumber,
            localeId: localeId,
            method: method,
            name: name
        },
        success: function (result, status, xhr) {
            if (result.message === 'Successfully created') {
                appState.validateTotpResponse = {
                    isValid: true,
                    mobileNumber: mobileNumber
                };
            } else {
                const responseResult = result && result.results ? result.results[0] : null;

                if (responseResult) {
                    if (responseResult[0].errorCode) {
                        appState.validateTotpResponse = {
                            errorCode: responseResult[0].errorCode,
                            placeholders: responseResult[0].placeholders,
                        };
                    }
                } else {
                    appState.validateTotpResponse = {
                        status: result.status,
                        placeholders: result.placeholders,
                    }
                }
            }
            LoginStore.emitValidateTwoFATotp();
        },
        error: function (err, status) {
            console.log('Valitadate TOTOP error: ', err)
            if (status === 401 || status === 403) {
                Utils.logoutRedirect()
            };

            appState.validateTotpResponse = err;
            LoginStore.emitValidateTwoFATotp();
        }
    })
}

LoginStore.getWebPageConfigurations = function (props, localeId) {
    var realm = props.realmId;
    var clientId = props.clientId;
    var countryCode = props.countryCode;
    var userType = props.userType;
    var preview = props.preview;

    localeId = localeId.replace('en-US', AppConstants.LOCALE_EN_GB).replace('xx-XX', AppConstants.LOCALE_EN_GB);
    const { url, method } = jsRoutes.controllers.web.ApplicationController.getFileContentOnCDN_V2(
        realm, clientId, countryCode, localeId || AppConstants.LOCALE_EN_GB, preview || false);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        type: 'get',
        success: function (result, status, xhr) {
            var data = defaultWebPageConfiguations;

            if (Utils.tryParseJSON(xhr.responseText)) {
                data = JSON.parse(xhr.responseText);
            }

            LoginStore.getLogoUrl(realm, clientId, countryCode, userType, data);
            LoginStore._setWebConfigurations(data, props, localeId);
            LoginStore.emitChange();
        },
        error: function (err) {
            console.log("Error ", err);
            LoginStore.getLogoUrl(realm, clientId, countryCode, userType, defaultWebPageConfiguations);
            LoginStore._setWebConfigurations(defaultWebPageConfiguations, props, localeId);
            LoginStore.emitChange();
        }
    });
}

LoginStore._setWebConfigurations = function (data, props, localeId) {
    appState.footerItems = data.footerLinks ? (data.footerLinks.items ? _.filter(data.footerLinks.items, function (o) { return !_.isEmpty(o.value); }) : []) : [];
    if (data.generalConfigurations && data.generalConfigurations.items && data.generalConfigurations.items.length) {
        var generalConfigurations = Utils.mapToKeyValue(data.generalConfigurations.items);
        appState.showLoginAsCustomerLink = generalConfigurations.showLoginAsCustomerLink;
        appState.showLoginAsEmployeeLinkInInternet = generalConfigurations.showLoginAsEmployeeLinkInInternet;
    }

    if (data.CustomerComponentLinks && data.CustomerComponentLinks.items && data.CustomerComponentLinks.items.length) {
        appState.customerComponentLinks = Utils.mapToKeyValue(data.CustomerComponentLinks.items);
        appState.hideYouAndMetroDigitalComponent = _.isEmpty(appState.customerComponentLinks.createLogin) && _.isEmpty(appState.customerComponentLinks.newCustomerSignUpButton) && _.isEmpty(appState.customerComponentLinks.signUpLink);
    }

    if (data.employeeLogin && data.employeeLogin.items && data.employeeLogin.items.length) {
        var employeeLogin = Utils.mapToKeyValue(data.employeeLogin.items);
        appState.employeeLoginRequiresOTP = employeeLogin.employeeLoginRequiresOTP;
    }

    var sectionToBeRead = '';
    switch (props.userType) {
        case AppConstants.UserTypes.CUST:
            sectionToBeRead = 'customerLogin';
            break;
        case AppConstants.UserTypes.SUPP:
            sectionToBeRead = 'supplierLogin';
            break;
        case AppConstants.UserTypes.DEV:
            sectionToBeRead = 'developerLogin';
            break;
        case AppConstants.UserTypes.EMP:
            sectionToBeRead = 'employeeLogin';
            break;
        default:
            sectionToBeRead = ''
            break;
    }

    var userTypeSectionData = data[sectionToBeRead] || {};

    if (props.userType == AppConstants.UserTypes.EMP)
        appState.forgotPwdLinkUrl = "";
    else
        appState.forgotPwdLinkUrl = UrlUtils.formForgotPwdLinkUrl(props, localeId);



    if (userTypeSectionData && userTypeSectionData.items && userTypeSectionData.items.length) {
        var items = Utils.mapToKeyValue(userTypeSectionData.items);
        var customizeForgotPwdLink = items.customizeForgotPwdLink;

        if (props.userType == AppConstants.UserTypes.EMP && customizeForgotPwdLink == "true") {
            appState.forgotPwdLinkUrl = items.forgotPwdLinkUrl;
        }
        else if (customizeForgotPwdLink == "true")
            appState.forgotPwdLinkUrl = items.forgotPwdLinkUrl;
    }

}


LoginStore.validateTOTP = function (totp, idToken, loginId, countryCode, realmId, userType, traceId) {
    const { url, method } = jsRoutes.controllers.web.ApplicationController.wrapValidateTOTP(idToken);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: {
            loginId: loginId,
            code: totp,
            countryCode: countryCode,
            realmId: realmId,
            userType: userType
        },
        success: function (result, status, xhr) {
            if (result.results[0].isValid) {
                appState.totp = {
                    isValid: result.results[0].isValid,
                };
            }
            else {
                var responseResult = result.results[0]
                appState.totp = {
                    errorCode: responseResult[0].errorCode,
                    placeholders: responseResult[0].placeholders
                };
            }
            LoginStore.emitTotpValidation();
        },
        failure: function (err) {
            console.log('err :', err);
        }
    })
}

LoginStore.validateTOTPWithSession = function (totp, idToken, loginId, countryCode, realmId, userType, traceId, startSessionIdentifier, totpType, totpName) {
    const { url, method } = jsRoutes.controllers.web.ApplicationController.wrapValidateTOTPWithSession(idToken);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: {
            code: totp,
            start_session_id: startSessionIdentifier,
            totp_type: totpType,
            totp_name: totpName
        },
        success: function (result, status, xhr) {
            const internalResult = result.results[0].results;
            if (internalResult) {
                const redirectURL = internalResult[0].redirectUrl;
                if (redirectURL) {
                    window.location.replace(redirectURL)
                } else {
                    appState.totp = {
                        errorCode: "0203301"
                    };
                }
            }
            else {
                const responseResult = result.results[0];
                appState.totp = {
                    errorCode: responseResult[0].errorCode,
                    placeholders: responseResult[0].placeholders
                };
            }
            LoginStore.emitTotpValidation();
        },
        failure: function (err) {
            console.log('err :', err);
        }
    })
}
LoginStore.validateAuthenticatorWithSession = function (authenticatorResponse, idToken, loginId, countryCode, realmId, userType, traceId, startSessionIdentifier, credentialId) {
    const verifyUserWebAuthnCredUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.VERIFY_USER_WEBAUTHN_CRED_URL);
    console.log("Register 2fa cred url : " + verifyUserWebAuthnCredUrl);
    $.ajax({
        url: verifyUserWebAuthnCredUrl,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId,
            'Authorization': 'Bearer ' + idToken,
        },
        type: 'post',
        data: {
            authenticator: authenticatorResponse,
            start_session_id: startSessionIdentifier,
            credential_id: credentialId
        },
        success: function (result, status, xhr) {
            console.log("Validate Authenticator Response : result ")
            console.log(result);
            console.log("Validate Authenticator Response : status :  " + status);
            const internalResult = result.results[0].results;
            if (internalResult) {
                const redirectURL = internalResult[0].redirectUrl;
                if (redirectURL) {
                    window.location.replace(redirectURL)
                } else {
                    appState.totp = {
                        errorCode: "0203301"
                    };
                }
            }
            else {
                const responseResult = result.results[0];
                appState.totp = {
                    errorCode: responseResult[0].errorCode,
                    placeholders: responseResult[0].placeholders
                };
            }
            LoginStore.emitTotpValidation();
        },
        failure: function (err) {
            console.log('err :', err);
        }
    })
}

LoginStore.validateAuthenticatorWithInitId = function (authenticatorResponse, initSessionId, loginId, traceId) {
    const validateWebauthnUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.VERIFY_USER_WEBAUTHN_CRED_URL_1FA);
    console.log("Validate 1fa cred url : " + validateWebauthnUrl);
    $.ajax({
        url: validateWebauthnUrl,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId,
        },
        type: 'post',
        data: {
            authenticator: authenticatorResponse,
            init_session_id: initSessionId,
            login_id: loginId
        },
        success: function (result, status, xhr) {
            console.log("Validate Authenticator Response : result ")
            console.log(result);
            console.log("Validate Authenticator Response : status : " + status);
            const internalResult = result.results[0].results;
            if (internalResult) {
                const redirectURL = internalResult[0].redirectUrl;
                if (redirectURL) {
                    window.location.replace(redirectURL)
                } else {
                    appState.totp = {
                        errorCode: "0203301"
                    };
                }
            }
            else {
                const responseResult = result.results[0];
                appState.totp = {
                    errorCode: responseResult[0].errorCode,
                    placeholders: responseResult[0].placeholders
                };
            }
            LoginStore.emitTotpValidation();
        },
        failure: function (err) {
            console.log('err :', err);
        }
    })
}


LoginStore.validateTOTPForgotPassword = function (totp, idToken, loginId, countryCode, realmId, userType, traceId) {
    const { url, method } = jsRoutes.controllers.web.ForgotPasswordController.encaseValidateTOTP(idToken);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: {
            loginId: loginId,
            code: totp,
            countryCode: countryCode,
            realmId: realmId,
            userType: userType
        },
        success: function (result, status, xhr) {
            if (result.invalidMailToken) {
                appState.totp = {
                    invalidMailToken: true,
                };
            }
            else {
                var responseResult = result && result.results ? result.results[0] : null;
                if (responseResult) {
                    if (responseResult.isValid) {
                        appState.totp = {
                            isValid: result.results[0].isValid,
                        };
                    }
                    else {
                        var responseResult = result.results[0]
                        appState.totp = {
                            errorCode: responseResult[0].errorCode,
                            placeholders: responseResult[0].placeholders
                        };
                    }
                }
                else {
                    appState.totp = {
                        errorCode: '0202001',
                    };
                }
            }
            LoginStore.emitTotpValidation();
        },
        failure: function (err) {
            console.log('err :', err);
            appState.totp = {
                errorCode: '0202001',
            };
        }
    })
}

LoginStore.resendTOTP = function (loginId, traceId, idToken, realmId, countryCode, userType, totpType, totpName, userRequested) {
    const { url, method } = jsRoutes.controllers.web.ApplicationController.wrapResendTOTP(loginId, idToken, realmId, countryCode, userType, totpType, totpName, userRequested);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'get',
        success: function (result, status, xhr) {
            let res = JSON.parse(result);
            let totpState = appState.totp || {};
            totpState.totpResent = res.status === "Success";
            let successTotpSentPhraseKey = '';
            if (res.status === 'Success' && !!res.mediaType) {
                if (res.mediaType.includes('mail') && res.mediaType.includes('sms'))
                    successTotpSentPhraseKey = 'totp_sent_successfully_sms_and_email';
                else if (res.mediaType.includes('mail'))
                    successTotpSentPhraseKey = 'totp_sent_successfully_email';
                else
                    successTotpSentPhraseKey = 'totp_sent_successfully';
            }
            totpState.errorCode = res.status === "Success" ? successTotpSentPhraseKey : res.errorCode ? "error" + res.errorCode : "totp_not_sent"
            appState.totp = totpState;
            LoginStore.emitTotpResent();
        },
        failure: function (err) {
            console.log('in errr block ', err);
            let totpState = appState.totp || {};
            totpState.totpResent = false;
            totpState.errorCode = "totp_not_sent"
            appState.totp = totpState;
            LoginStore.emitTotpResent();
        }

    });
}


LoginStore.genAndSendOtpUsingTempSecret = function (userType, idToken, mobileNumber, countryCode, traceId, resendFlag) {
    let { url, method } = jsRoutes.controllers.web.LoginPreferencesController.wrapGenAndSendOtpUsingTempSecret(userType, mobileNumber, countryCode);

    resendFlag && (url = UrlUtils.setQueryParameter('resend', true, url))
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            [AppConstants.UrlParams.TRACE_ID]: traceId,
            'Authorization': idToken
        },
        type: 'get',
        success: function (result, status, xhr) {
            let otpViaSms = appState.otpViaSms || {};
            otpViaSms.isOtpSent = false;

            if (result.message == 'SUCCESS') {

                otpViaSms.isOtpSent = true;
                if (result && result.results && result.results[0]) {
                    otpViaSms.placeholders = result.results[0].placeholders;

                }
            }
            // Invalid ID Tokem scenario or ID token expired scenario
            else if (result.message == 'Unknown Auth Token' || result.message == 'Unauthorized Request') {
                // No error code received to set in this case. Hence setting a custom error code
                // for the case when id token expires or is invalid
                otpViaSms.errorCode = '0999999';

            } else {
                if (result && result.results && result.results[0] && result.results[0][0]) {
                    if (result.results[0][0].errorCode === "0203005") {
                        setCodesViaSmsTOTPValidityTimestamp()
                    }
                    else {
                        removeCodesViaSmsTOTPValidityTimestamp()
                    }

                    otpViaSms.errorCode = result.results[0][0].errorCode;
                    otpViaSms.placeholders = result.results[0][0].placeholders;

                } else {
                    otpViaSms.errorCode = '0202001';
                }
            }

            appState.otpViaSms = otpViaSms;
            LoginStore.emitOtpSentViaSms();
        },
        error: function (error) {
            let otpViaSms = {};

            function getErrorCode(error) {
                if (error.responseJSON.results && error.responseJSON.results.length > 0) {
                    return error.responseJSON.results[0].map(v => v.errorCode)[0];
                }
                else if (error.results && error.results.length > 0) {
                    return error.results[0].map(v => v.errorCode)[0];
                }
                else return '';
            }

            let errorCode = getErrorCode(error);
            if (!!errorCode)
                otpViaSms.errorCode = errorCode;
            else
                otpViaSms.errorCode = "0202001";

            appState.otpViaSms = otpViaSms;
            LoginStore.emitOtpSentViaSms();
        },
        failure: function (err) {
            console.log(err, 'failure')
            let otpViaSms = appState.otpViaSms || {};
            otpViaSms.isOtpSent = false;
            otpViaSms.errorCode = '0202001';
            appState.otpViaSms = otpViaSms;
            LoginStore.emitOtpSentViaSms();
        }
    });
}

LoginStore.getUserMFAMethods = function (idToken, countryCode) {
    if (['', undefined].includes(idToken)) {
        appState.userMFAMethods = [];
        LoginStore.emitGetUserMFAOptions();
    } else {
        const { url, method } = jsRoutes.controllers.web.UserController.getUserAuthMethods();
        $.ajax({
            url,
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + idToken
            },
            data: {
                country_code: countryCode
            },
            type: 'get',
            async: false,
            success: function (result, status, xhr) {
                appState.userMFAMethods = result.results;
                LoginStore.emitGetUserMFAOptions();
            },
            error: function (err) {
                appState.userMFAMethods = [];
                LoginStore.emitGetUserMFAOptions();
            }
        });
    }
}

LoginStore.setIsIntranetRequestV2 = function () {
    try {
        const url = "https://idam-dev.metrosystems.net";
        const method = "GET";
        $.ajax({
            url,
            method,
            headers: {},
            type: 'get',
            async: false,
            success: function (result, status, xhr) {
                appState.IsIntranetRequestV2 = true;
                LoginStore.emitSetIsIntranetRequestV2();
            },
            error: function (error) {
                console.log('err :', error);

                appState.IsIntranetRequestV2 = !!error.responseText;
                LoginStore.emitSetIsIntranetRequestV2();
            },
            timeout: 1000 // sets timeout to 1 seconds
        });
    }
    catch (e) {
        console.log('setIsIntranetRequestV2 catched exception :', e);

        appState.IsIntranetRequestV2 = false;
        LoginStore.emitSetIsIntranetRequestV2();
    }
}

LoginStore.getPasswordlessInfo = function (loginId, userType) {
    const { url, method } = jsRoutes.controllers.web.PasswordlessController.wrapUserPasswordlessStatus(loginId, userType);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/json',
        },
        type: 'get',
        async: false,
        success: function (result, status, xhr) {
            const passwordlessInfo = JSON.parse(result);
            appState.isPasswordlessUser = passwordlessInfo.results[0].isPasswordless;
            LoginStore.emitGetPasswordlessInfo();
        },
        error: function (err) {
            console.log('err :', err);
            appState.isPasswordlessUser = false;
            LoginStore.emitGetPasswordlessInfo();
        }
    });
}


LoginStore.getPasswordlessMethods = function (clientId, loginId, userType) {
        const { url, method } = jsRoutes.controllers.web.PasswordlessController.wrapPasswordlessMethods(clientId, loginId, userType);
        $.ajax({
            url,
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            type: 'get',
            async: false,
            success: function (result, status, xhr) {
                appState.userPasswordlessMethods = [];
                appState.userLoginId = "";
                const methods = JSON.parse(result);
                appState.userPasswordlessMethods = methods.results[0];
                appState.userLoginId = loginId;
                LoginStore.emitGetPasswordlessMethods();
            },
            error: function (err) {
                console.log('err :', err);
                LoginStore.emitGetPasswordlessMethods();
            }
        });
}

LoginStore.validateOtpAuth = function (loginId, userType, otp, countryCode, fwd_client_id) {
    const { url, method } = jsRoutes.controllers.web.PasswordlessController.wrapValidateOtpAuth(loginId, userType, otp, countryCode, fwd_client_id);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        type: 'post',
        data: {
            loginId: loginId,
            userType: userType,
            otp: otp,
            countryCode: countryCode,
            fwd_client_id: fwd_client_id ? fwd_client_id : "undefined"
        },
        success: function (result, status, xhr) {
            let res = JSON.parse(result);
            appState.AuthCode = {
                "result": res.message, //xhr.responseText,
                "redirecturi": res.results[0].redirectUrl, //xhr.getResponseHeader('url'),
                "code": res.results[0].code, //xhr.getResponseHeader('Authenticated')
                "session_state": res.results[0].session_state,
                "status": res.status,
            };

            appState.otp = {
                error: false
            };

            window.location = res.results[0].redirectUrl;
            LoginStore.emitOtpValidation();
        },
        error: function (err) {
            let response = JSON.parse(err.responseText)
            appState.otp = {
                error: true,
                message: response.error_description,
            };
            console.log('err :', err);
        }
    })
}

LoginStore.generateOtpCode = function (userId, isClientPasswordless, userType, clientId, responseType,
    countryCode, localeId, realmId, accountId, redirectUrl, state, prompt, nonce, scope, traceId, codeChallenge, codeChallengeMethod) {
    var data = {
        'login_id': userId,
        'passwordless': isClientPasswordless,
        'user_type': userType,
        'client_id': clientId,
        'response_type': responseType,
        'country_code': countryCode,
        'locale_id': localeId,
        'realm_id': realmId,
        'account_id': accountId,
        'redirect_url': redirectUrl,
        'state': state,
        'prompt': prompt,
        'nonce': nonce,
        'scope': scope,
        'code_challenge': codeChallenge,
        'code_challenge_method': codeChallengeMethod,
    };

    const { url, method } = jsRoutes.controllers.web.PasswordlessController.wrapGenerateAndSendOtp();
    return new Promise(function(resolve, reject) {
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: Utils.removeEmptyValues(data, ['prompt']),
        success: function(data) {
            resolve(data) 
            appState.genOtpHasError = false;

            LoginStore.emitGenerateOtpCode();
        },
        error: function (err) {
            let response = JSON.parse(err.responseText);
            if(response.results && response.results[0] && response.results[0][0] && response.results[0][0].errorCode === "0201025"){
                reject(err)
                appState.genOtpHasError = true;
            }
            LoginStore.emitGenerateOtpCode();
        }
    });
})
}

LoginStore.checkAuthentication = function (userId, password, userType, clientId, responseType,
    countryCode, localeId, realmId, accountId, redirectUrl, state, prompt, nonce, scope, traceId, codeChallenge, codeChallengeMethod,
    captchaToken) {
    var AuthCode = {};
    var data = {
        'user_id': userId,
        'password': password,
        'user_type': userType,
        'client_id': clientId,
        'response_type': responseType,
        'country_code': countryCode,
        'locale_id': localeId,
        'realm_id': realmId,
        'account_id': accountId,
        'redirect_url': redirectUrl,
        'state': state,
        'prompt': prompt,
        'nonce': nonce,
        'scope': scope,
        'code_challenge': codeChallenge,
        'code_challenge_method': codeChallengeMethod,
        'rc_token': captchaToken
    };

    const { url, method } = jsRoutes.controllers.web.ApplicationController.wrapAuthenticate();
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: Utils.removeEmptyValues(data, ['prompt']),
        success: function (result, status, xhr) {
            appState.AuthCode = {
                "result": result.result, //xhr.responseText,
                "redirecturi": result.url, //xhr.getResponseHeader('url'),
                "message": result.message, //xhr.getResponseHeader('Authenticated')
                "status": xhr.status 
            };

            appState.totp = {
                isValid: false
            };

            LoginStore.emitLoginChange();
        },
        error: function (err, status) {
            if (err.status === 403 || err.status === 401) {
                appState.AuthCode = {
                    "result": err.responseJSON.result,
                    "message": err.responseJSON.message
                };

                LoginStore.emitLoginChange();
                return;
            }else if (err.status === 400) {
                redirectUrl = redirectUrl ? redirectUrl : window.origin + AppConstants.Links.ERROR_PAGE //symptom fix - this case will come in picture when /web/Signin route's query param is muted
                var errRes = Utils.tryParseJSON(err.responseText);
                // if unable to parse response
                if (!errRes) {
                    appState.AuthCode = {
                        "result": err,
                        "redirecturi": UrlUtils.setQueryParameter('error', 'Bad Request', window.origin + AppConstants.Links.ERROR_PAGE)
                    };
                    LoginStore.emitLoginChange();
                    return;
                }
                // if res is parse successfully

                // if the redirect uri or client_id is missing/invalid then we will redirect to IDAM custom error page
                //( as per security recommendations)
                if (errRes.error == 'redirect_uri_mismatch' || errRes.error == 'invalid_client') { redirectUrl = window.origin + AppConstants.Links.ERROR_PAGE }

                if (errRes.error_description == 'nonce is missing_or_repeated') {
                    redirectUrl = UrlUtils.setHashParameter('error', errRes.error, redirectUrl);
                    redirectUrl = UrlUtils.setHashParameter('error_description', errRes.error_description, redirectUrl);
                } else {
                    redirectUrl = UrlUtils.setQueryParameter('error', errRes.error, redirectUrl);
                    redirectUrl = UrlUtils.setQueryParameter('error_description', errRes.error_description, redirectUrl);
                }

                appState.AuthCode = {
                    "result": err,
                    "redirecturi": redirectUrl
                };
                LoginStore.emitLoginChange();
            }else{
                console.log(err)
                appState.AuthCode = {
                    "result": err.responseJSON.result,
                    "message": err.responseJSON.message
                };

                LoginStore.emitLoginChange();
                return;
            }
        },
        failure: function (err) {
            appState.AuthCode = {
                "result": err
            };
            LoginStore.emitLoginChange();
        }

    });

    return AuthCode;
}

LoginStore.checkAuthenticationWithPasscode = function (userId, password, oneTimePasscode, userType, clientId, responseType,
    countryCode, localeId, realmId, accountId, redirectUrl, state, nonce, scope, traceId, codeChallenge, codeChallengeMethod) {

    var AuthCode = {};

    const { url, method } = jsRoutes.controllers.web.ApplicationController.wrapAuthenticateWithOtp();
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: {
            'login_id': userId,
            'password': password,
            'code': oneTimePasscode,
            'user_type': userType,
            'client_id': clientId,
            'response_type': responseType,
            'country_code': countryCode,
            'locale_id': localeId,
            'realm_id': realmId,
            'account_id': accountId,
            'redirect_uri': redirectUrl,
            'state': state,
            'nonce': nonce,
            'scope': scope,
            'code_challenge': codeChallenge,
            'code_challenge_method': codeChallengeMethod
        },
        success: function (result, status, xhr) {
            if (result.result) {
                appState.AuthCode = {
                    "result": result.result, //xhr.responseText,
                    "redirecturi": result.url, //xhr.getResponseHeader('url'),
                };
            } else {
                appState.AuthCode = {
                    "result": result, //xhr.responseText,
                };
            }

            appState.totp = {
                isValid: false
            };

            LoginStore.emitLoginWithPasscodeChange();
        },
        error: function (err, status) {

            if (err.status === 400) {
                redirectUrl = redirectUrl ? redirectUrl : window.origin + AppConstants.Links.ERROR_PAGE //symptom fix - this case will come in picture when /web/Signin route's query param is muted
                var errRes = Utils.tryParseJSON(err.responseText);
                // if unable to parse response
                if (!errRes) {
                    appState.AuthCode = {
                        "result": err,
                        "redirecturi": UrlUtils.setQueryParameter('error', 'Bad Request', window.origin + AppConstants.Links.ERROR_PAGE)
                    };
                    LoginStore.emitLoginWithPasscodeChange();
                    return;
                }
                // if res is parse successfully

                // if the redirect uri or client_id is missing/invalid then we will redirect to IDAM custom error page
                //( as per security recommendations)
                if (errRes.error == 'redirect_uri_mismatch' || errRes.error == 'invalid_client') { redirectUrl = window.origin + AppConstants.Links.ERROR_PAGE }

                if (errRes.error_description == 'nonce is missing_or_repeated') {
                    redirectUrl = UrlUtils.setHashParameter('error', errRes.error, redirectUrl);
                    redirectUrl = UrlUtils.setHashParameter('error_description', errRes.error_description, redirectUrl);
                } else {
                    redirectUrl = UrlUtils.setQueryParameter('error', errRes.error, redirectUrl);
                    redirectUrl = UrlUtils.setQueryParameter('error_description', errRes.error_description, redirectUrl);
                }

                appState.AuthCode = {
                    "result": err,
                    "redirecturi": redirectUrl
                };
                LoginStore.emitLoginWithPasscodeChange();
            }
        },
        failure: function (err) {
            appState.AuthCode = {
                "result": err
            };
            LoginStore.emitLoginWithPasscodeChange();
        }

    });

    return AuthCode;
}

LoginStore.checkSamlAuthentication = function (userId, password, userType, clientId,
    countryCode, localeId, realmId, traceId) {

    var SamlResponse = {};
    var host = window.location.host.indexOf('localhost') != -1 ? 'localhost:9011' : window.location.host;
    var processSamlReqUrl = window.location.protocol + "//" + host + AppConstants.Links.PROCESS_SAML_URL + "?" +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.CLIENT_ID, clientId) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, userType) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, countryCode) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, localeId) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, realmId) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, traceId)
    var { url, method } = jsRoutes.controllers.web.ApplicationController.wrapSamlAuthenticate();
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'post',
        data: {
            'login_id': userId,
            'password': password,
            'client_id': clientId,
            'user_type': userType,
            'realm_id': realmId,
            'locale_id': localeId,
            'country_code': countryCode
        },
        success: function (result, status, xhr) {
            appState.SamlResponse = {
                "result": result.message,
                "redirecturi": processSamlReqUrl
            };
            LoginStore.emitSamlLoginChange();
        },
        error: function (err, status) {
            var errRes = Utils.tryParseJSON(err.responseText);
            // if unable to parse response
            if (!errRes) {
                appState.SamlResponse = {
                    "result": err,
                    "redirecturi": UrlUtils.setQueryParameter('error', 'Bad Request', window.origin + AppConstants.Links.ERROR_PAGE)
                };
                LoginStore.emitSamlLoginChange();
                return;
            }
            appState.SamlResponse = {
                "result": errRes.result,
                "message": errRes.message
            };
            LoginStore.emitSamlLoginChange();
        },
        failure: function (err) {
            appState.SamlResponse = {
                "result": err
            };
            LoginStore.emitSamlLoginChange();
        }
    });
    return SamlResponse;
}

LoginStore.getSupportedLocales = function (realmId, countryCode, localeId) {
    var supportedLocales = '';
    var defaultLocale = localeId || AppConstants.LOCALE_EN_GB;

    const { url, method } = jsRoutes.controllers.web.ApplicationController.wrapGetLocalesByRealmCountry(realmId, countryCode);
    $.ajax({
        url,
        method,
        async: false,
        success: function (result) {
            for (var key in result) {
                supportedLocales = result[key].locales;
                appState.supportedLocales = supportedLocales;
            }

            appState.localeId = defaultLocale;
            LoginStore.getLocale(defaultLocale, countryCode);
            LoginStore.emitSupportedLocalesReceived();
            LoginStore.getTranslations(countryCode, defaultLocale);

        },
        failure: function (err) {
            console.log('Error in retrieving supported locales');
            LoginStore.getTranslations(countryCode, localeId);
        }
    });
};

LoginStore.getUserLoginStrategy = function (countryCode, userType) {
    const { url, method } = jsRoutes.controllers.web.ConfigurationParameterController.allowMobileLogin(countryCode, userType || AppConstants.UserTypes.CUST);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'get',
        success: function (result, status, xhr) {
            appState.allowMobileLogin = result.allowMobileLogin;
            LoginStore.emitUserLoginStartegyReceived();
        },
        failure: function (err) {
            console.log('Error in retrieving user login strategy');
            appState.allowMobileLogin = false;
            LoginStore.emitUserLoginStartegyReceived();
        }
    })
}

LoginStore.getMFAOptions = function (userType, countryCode) {
    const { url, method } = jsRoutes.controllers.web.ConfigurationParameterController.getMFAOptions(userType, countryCode || AppConstants.DEFAULT_COUNTRY_CODE);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'get',
        success: function (result, status, xhr) {
            console.log(result);
            appState.mfaOptions = result;
            LoginStore.emitGetMFAOptionsReceived();
        },
        failure: function (err) {
            console.log('Error in retrieving user login strategy');
            appState.mfaOptions = {};
            LoginStore.emitGetMFAOptionsReceived();
        }
    })
}

LoginStore.getLocale = function (localeId, countryCode) {
    localeId = localeId || AppConstants.countryDefaultLocaleId[countryCode.toUpperCase()]
    return localeId;
}

LoginStore.forgotPassword = function (user_id, urlDetails, notificationChannel) {
    if (window.location.host.indexOf('localhost') != -1) { var host = 'localhost:9001'; } else { var host = window.location.host; }
    var return_url = window.location.protocol + "//" + host + AppConstants.Links.AUTHORIZE_URL + "?" +
        AppConstants.UrlParams.CLIENT_ID + "=" + urlDetails.clientId +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, urlDetails.redirectUrl) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, urlDetails.userType) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, urlDetails.responseType) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, urlDetails.countryCode) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, urlDetails.accountId) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, urlDetails.localeId) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, urlDetails.realmId) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, urlDetails.scope) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, urlDetails.nonce) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, urlDetails.state) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE, urlDetails.codeChallenge) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE_METHOD, urlDetails.codeChallengeMethod) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, urlDetails.traceId)

    const { url, method } = jsRoutes.controllers.web.ForgotPasswordController.forgotPassword_3()
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Csrf-token': 'nocheck',
            [AppConstants.UrlParams.TRACE_ID]: urlDetails.traceId
        },
        type: 'post',
        data: {
            'channelName': user_id,
            'notificationChannel': notificationChannel,
            'userType': urlDetails.userType,
            'successUrl': encodeURI(return_url),
            'expirationUrl': encodeURI(return_url),
            'realmId': urlDetails.realmId,
            'clientId': urlDetails.clientId,
            'countryCode': urlDetails.countryCode,
            'localeId': urlDetails.localeId
        },
        success: function (result, status, xhr) {
            let mailToken = result.results[0] ? result.results[0].replace('MailToken:', '') : '';
            appState.ForgotPasswordCode = {
                "status": result.status,
                "message": result.message,
                'mailToken': mailToken
            };
            LoginStore.emitForgotPasswordChange();
        },
        error: function (err) {
            var response = JSON.parse(err.responseText)
            appState.ForgotPasswordCode = {
                "status": response.status,
                "message": response.message,
                "errorCode": response.results[0][0] ? response.results[0][0].errorCode : AppConstants.GENERIC_ERROR_CODE
            };
            LoginStore.emitForgotPasswordChange();
        }

    });
}

LoginStore.changePassword = function (loginId, currentPassword, newPassword, userType, traceId) {
    const { url, method } = jsRoutes.controllers.web.ApplicationController.handleChangePassword()
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [AppConstants.UrlParams.TRACE_ID]: traceId
        },
        type: 'put',
        data: {
            'login_id': loginId,
            'old_password': currentPassword,
            'new_password': newPassword,
            'user_type': userType
        },
        success: function (result, status, xhr) {

            if (result.status == AppConstants.ApiResponse.SUCCESS) {
                appState.changePasswordCode = {
                    "status": result.status
                };
            }
            else {
                appState.changePasswordCode = {
                    "status": result.status,
                    "errorCode": result.errorCode,
                    "errorMessage": result.errorMessage
                };
            }
            LoginStore.emitChangePasswordChange();
        },
        failure: function (err) {
            appState.changePasswordCode = {
                "status": err
            };
            LoginStore.emitChangePasswordChange();
        }

    });
}

LoginStore.getLogoUrl = function (realm_Id, clientId, countryCode, userType, webConfiguration) {
    const cdnBaseUrl = window.WebConstants.cdnBaseUrl.replace("http", "https");
    var branding = webConfiguration.branding ? (webConfiguration.branding.items ? _.filter(webConfiguration.branding.items, function (o) { return !_.isEmpty(o.value); }) : null) : null;

    if (!_.isEmpty(branding)) {
        const cdnLogoPath = cdnBaseUrl + AppConstants.CdnAssetsPath.BRANDING_LOGOS_PATH;
        const cdnFaviconPath = cdnBaseUrl + AppConstants.CdnAssetsPath.BRANDING_FAVICONS_PATH;
        let brandingVariant = (branding && branding[0] && branding[0].value) || 0;
        appState.brandInfoItem = {
            srcLogoUrl: cdnLogoPath + AppConstants.Metro_Logo_Variant_Mapping[brandingVariant],
            faviconUrl: cdnFaviconPath + AppConstants.Metro_Logo_Variant_Mapping[brandingVariant],
            logoLink: (branding && branding[0] && branding[0].logoLink) || "",
            deviantLogoCss: _.includes(AppConstants.Deviant_Logos.logos, brandingVariant)
        };
        LoginStore.emitChange();
    }
    else {

        var localImageHostUrl = window.location.protocol + '//' + window.location.host + '/web/assets/IDAM/images/';
        localImageHostUrl = localImageHostUrl + (userType === 'CUST' ? 'metro_logo_header.png' : 'header_logo_img.png');

        appState.brandInfoItem = {
            logoLink: AppConstants.headerLogoRedirectUrls[countryCode]
        }

        if (realm_Id && clientId) {
            var imageName = userType === 'CUST' ? AppConstants.CdnAssetsPath.HEADER_CUST_LOGO_IMG_REL_PATH : AppConstants.CdnAssetsPath.HEADER_LOGO_IMG_REL_PATH;
            var headerImage = new Image();
            var headerImageUrl = (cdnBaseUrl + '/' + realm_Id + '/' + clientId + '/' + countryCode + imageName);
            var favIconUrl = (cdnBaseUrl + '/' + realm_Id + '/' + clientId + '/' + countryCode + AppConstants.CdnAssetsPath.FAVICON_IMG_REL_PATH);
            headerImage.onload = function () {
                appState.brandInfoItem.srcLogoUrl = headerImageUrl;
                appState.brandInfoItem.faviconUrl = favIconUrl;
                LoginStore.emitChange();
            };
            headerImage.onerror = function () {
                var logo = userType === 'CUST' ? AppConstants.CdnAssetsPath.HEADER_CUST_LOGO_IMG : AppConstants.CdnAssetsPath.HEADER_LOGO_IMG;
                var countryLogo = new Image();
                var countryLogoUrl = (cdnBaseUrl + '/country_logo/' + countryCode + logo);
                favIconUrl = (cdnBaseUrl + '/country_logo/' + countryCode + AppConstants.CdnAssetsPath.FAVICON_IMG);
                countryLogo.onload = function () {
                    appState.brandInfoItem.srcLogoUrl = countryLogoUrl;
                    appState.brandInfoItem.faviconUrl = favIconUrl;
                    LoginStore.emitChange();
                };
                countryLogo.onerror = function () {
                    appState.brandInfoItem.srcLogoUrl = localImageHostUrl;
                    appState.brandInfoItem.faviconUrl = AppConstants.CdnAssetsPath.FAVICON_IMG_ASSET_URL;
                    LoginStore.emitChange();
                };
                countryLogo.src = countryLogoUrl;
            };
            headerImage.src = headerImageUrl;
        }
        else {
            var countryLogo = new Image();
            var logo = userType === 'CUST' ? AppConstants.CdnAssetsPath.HEADER_CUST_LOGO_IMG : AppConstants.CdnAssetsPath.HEADER_LOGO_IMG;
            var countryLogoUrl = (cdnBaseUrl + '/country_logo/' + countryCode + logo);
            var favIconUrl = (cdnBaseUrl + '/country_logo/' + countryCode + AppConstants.CdnAssetsPath.FAVICON_IMG);
            countryLogo.onload = function () {
                appState.brandInfoItem.srcLogoUrl = countryLogoUrl;
                appState.brandInfoItem.faviconUrl = favIconUrl;
                LoginStore.emitChange();
            };
            countryLogo.onerror = function () {
                appState.brandInfoItem.srcLogoUrl = localImageHostUrl;
                appState.brandInfoItem.faviconUrl = AppConstants.CdnAssetsPath.FAVICON_IMG_ASSET_URL;
            };
            countryLogo.src = countryLogoUrl;
        }
    }
}

LoginStore.getTranslations = function (countryCode, localeId) {
    localeId = localeId.replace('en-US', AppConstants.LOCALE_EN_GB);//replace en-US by en_GB as supported in phraseapp
    const { url, method } = jsRoutes.controllers.web.TranslationsController.getTranslations(countryCode, localeId);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'get',
        success: function (result, status, xhr) {
            appState.translations = result;
            LoginStore.emitTranslationsReceived();
        }
    })
}

LoginStore.resetPassword = function (password, urlDetails) {
    const { url, method } = jsRoutes.controllers.web.ForgotPasswordController.handleResetPassword_v1()
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Csrf-token': 'nocheck',
            [AppConstants.UrlParams.TRACE_ID]: urlDetails.traceId
        },
        type: 'post',
        data: {
            'mailToken': urlDetails.token,
            'password': password
        },
        dataType: 'json',
        success: function (result, status, xhr) {
            appState.ResetPasswordCode = {
                "status": result.status,
                "url": result.results[0] ? result.results[0].successUrl : null
            };
            LoginStore.emitResetPasswordChange();
        },
        error: function (err) {
            var response = JSON.parse(err.responseText)
            appState.ResetPasswordCode = {
                "errorCode" : response.results[0] && response.results[0][0] ? response.results[0][0].errorCode : null,
                "status": response.status,
                "url": response.results[0][0] && response.results[0][0].moreInfo ? response.results[0][0].moreInfo.expirationUrl : null,
                "ErrorMsg": response.results[0][0] ? response.results[0][0].errorMessage : null
            };
            LoginStore.emitResetPasswordChange();
        }

    });
}

LoginStore.displayToast = function (toastMessage, toastType, clearToast, title) {
    appState.toast = {
        "toastMessage": toastMessage,
        "toastType": toastType,
        "clearToast": clearToast,
        "title": title
    }
    LoginStore.emitToastChange();
}

LoginStore.allowX509Login = function (clientId) {
    var { url, method } = jsRoutes.controllers.web.ConfigurationParameterController.allowX509Login(clientId);
    $.ajax({
        url,
        method,
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'get',
        success: function (result, status, xhr) {
            appState.allowX509Login = result
            LoginStore.emitallowX509LoginReceived();
        },
        failure: function (err) {
            console.log('Error in retrieving allowX509Login info');
            appState.allowX509Login = false;
            LoginStore.emitallowX509LoginReceived();
        }
    })
}

LoginStore.createWebauthnCredentials = function (idToken, challenge, userId, email, traceId) {
    const publicKeyCredentialCreationOptions = {
        challenge: Uint8Array.from(
            challenge, c => c.charCodeAt(0)),
        rp: {
            name: "Metro IDAM",
            id: window.location.hostname
        },
        user: {
            id: Uint8Array.from(
                userId, c => c.charCodeAt(0)),
            name: email,
            displayName: email,
        },
        pubKeyCredParams: [{
            "type": "public-key",
            "alg": -7
        },
        {
            "type": "public-key",
            "alg": -35
        },
        {
            "type": "public-key",
            "alg": -36
        },
        {
            "type": "public-key",
            "alg": -257
        },
        {
            "type": "public-key",
            "alg": -258
        },
        {
            "type": "public-key",
            "alg": -259
        },
        {
            "type": "public-key",
            "alg": -37
        },
        {
            "type": "public-key",
            "alg": -38
        },
        {
            "type": "public-key",
            "alg": -39
        },
        {
            "type": "public-key",
            "alg": -8
        }],
        timeout: 60000,
        attestation: "direct"
    };
    console.log(JSON.stringify(publicKeyCredentialCreationOptions));
    navigator.credentials.create({
        publicKey: publicKeyCredentialCreationOptions
    }).then((pubKeyCredCaptured) => {
        var jsonPubKeyCred = Utils.publicKeyCredentialToJSON(pubKeyCredCaptured);
        appState.userCredentialsCreated = jsonPubKeyCred;
        LoginStore.emitUserCredentialsCreated();
    });
}
LoginStore.save2faCred = function (idToken, webAuthnResponse, userId, deviceName, userType, traceId, mfaOption = '', authDetails = {}, isAdd = false) {
    const registerWebauthnUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.VALIDATE_AND_REGISTER_WEBAUTHN_CRED);
    console.log("Register 2fa cred url : " + registerWebauthnUrl);
    const registrationRequest = JSON.stringify({
        "deviceName": deviceName,
        "registrationCredential": webAuthnResponse
    });
    $.ajax({
        url: registerWebauthnUrl + "/" + userId,
        headers: {
            'Content-Type': 'application/json',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': 'Bearer ' + idToken,
            'Csrf-Token': 'nocheck'
        },
        type: 'post',
        data: registrationRequest,
        success: function (result, status, xhr) {
            console.log("save2faCred response status: " + status);
            console.log("save2faCred response result:", result);
            let saveStatus = result.status ? result.status : '';
            if (saveStatus === 201) {
                const updateReamrks = "Updating authentication method of user " + userId + " from web";
                const addReamrks = "Adding authentication method of user " + userId + " from web";
                if (isAdd) {
                    LoginStore.addUserAuthnMethod(idToken, userId, userType, addReamrks, AppConstants.TWO_FA_WEB_AUTHN, traceId, deviceName, mfaOption, authDetails)
                } else {
                    LoginStore.updateUserAuthnMethod(idToken, userId, userType, updateReamrks, AppConstants.TWO_FA_WEB_AUTHN, traceId)
                }
            } else {
                // appState.updateAuthnMethodError = true;
                LoginStore.emitSave2FAWebAuthn();
            }
            return;
        },
        error: function (xhr, status, err) {
            console.log("Failed to save Webauthn details :", err);
            if (status === 401 || status === 403) {
                Utils.logoutRedirect()
            };

            appState.updateAuthnMethodError = true;
            LoginStore.emitSave2FAWebAuthn();
        }
    });
}
LoginStore.get2faWebAuthnCredentials = function (idToken, userId, traceId) {
    const getWebauthnUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.GET_USERWEBAUTHN_CRED_URL);
    console.log("GET 2fa cred url : " + getWebauthnUrl);
    $.ajax({
        url: getWebauthnUrl + "/" + userId,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': 'Bearer ' + idToken,
        },
        type: 'get',

        success: function (result, status, xhr) {
            console.log("get2faWebAuthnCredentials Status code :" + status);
            console.log("get2faWebAuthnCredentials result :" + result);

            appState.allowedCredentials = result.results[0].authenticators.map(obj => { return obj.credential });
            appState.userWebauthnDevices = result.results[0].authenticators.map(obj => { return { deviceName: obj.deviceName, credId: obj.keyId } });
            appState.challenge = result.results[0].challenge;
            console.log("challenge receievd in ajax call: " + appState.challenge);
            LoginStore.emitWebauthnCredentials();
            return;

        },
        error: function (xhr, status, err) {
            console.log('Error in retrieving user webauthn registered keys: ' + err);
            appState.fetchWebauthnFailure = true;
            LoginStore.emitWebauthnCredentials();
            return;
        }
    });
}
LoginStore.get2faWebAuthnCredentialsForLogin = function (idToken, userId, traceId) {
    const getWebauthnUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.GET_USERWEBAUTHN_CRED_URL_FOR_LOGIN);
    console.log("GET 2FA cred url : " + getWebauthnUrl);
    $.ajax({
        url: getWebauthnUrl + "/" + userId,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': 'Bearer ' + idToken,
        },
        type: 'get',

        success: function (result, status, xhr) {
            console.log("get2faWebAuthnCredentialsForLogin Status code: " + status);
            console.log("get2faWebAuthnCredentialsForLogin result :" + result);

            appState.allowedCredentials = result.results[0].authenticators.map(obj => { return obj });
            appState.challenge = result.results[0].challenge;
            console.log("Challenge receievd in ajax call: " + appState.challenge);
            LoginStore.emitWebauthnCredentials();
            return;

        },
        error: function (xhr, status, err) {
            console.log('Error in retrieving user webauthn registered keys: ' + err);
            appState.fetchWebauthnFailure = true;
            LoginStore.emitWebauthnCredentials();
            return;
        }
    });
}

LoginStore.get1faWebAuthnCredentialsForLogin = function (loginId, userType, clientId, realmId, initSessionId, traceId) {
    const getWebauthnUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.GET_USERWEBAUTHN_CRED_URL_FOR_LOGIN);
    console.log("GET 1FA cred url : " + getWebauthnUrl);
    $.ajax({
        url: getWebauthnUrl,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Csrf-Token': 'nocheck',
        },
        data: {
            login_id: loginId,
            user_type: userType,
            client_id: clientId,
            realm_id: realmId,
            init_session_id: initSessionId
        },
        type: 'get',

        success: function (result, status, xhr) {
            console.log("get1faWebAuthnCredentialsForLogin Status code: " + status);
            console.log("get1faWebAuthnCredentialsForLogin result :" + result);

            appState.allowedCredentials = result.results[0].authenticators.map(obj => { return obj });
            appState.challenge = result.results[0].challenge;
            console.log("Challenge receievd in ajax call: " + appState.challenge);
            appState.response1FaCredential = true;
            LoginStore.emitWebauthnCredentials();
            return;

        },
        error: function (xhr, status, err) {
            console.log('Error in retrieving user webauthn registered keys: ' + err);
            // appState.fetchWebauthnFailure = true;
            appState.response1FaCredential = false;
            LoginStore.emitWebauthnCredentials();
            return;
        }
    });
}

LoginStore.delete2faWebAuthnCredentials = function (idToken, deviceName, credentialId, userId, traceId) {
    const deleteWebauthnUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.DELETE_USERWEBAUTHN_CRED_URL);
    console.log("DELETE 2fa cred url : " + deleteWebauthnUrl);
    $.ajax({
        url: deleteWebauthnUrl + "/" + userId + "/" + credentialId,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': 'Bearer ' + idToken,
            'Csrf-Token': 'nocheck'
        },
        type: 'delete',

        success: function (result, status, xhr) {
            console.log("delete2faWebAuthnCredentials Status code :" + status);
            console.log("delete2faWebAuthnCredentials result :" + JSON.stringify(result));

            appState.credentialDeleted = true

            LoginStore.emitWebauthnCredentialsDeleted();
            return;

        },
        error: function (err) {
            console.log('Error in deleting webauthn registered key : ' + deviceName);
            appState.credentialDeleted = false;
            LoginStore.emitWebauthnCredentialsDeleted();
            return;
        }
    });
}
LoginStore.captureWebauthnCredentials = function (challenge, allowedCredList) {
    console.log('inside ... captureWebauthnCredentials');
    var allowedCred = allowedCredList.map(obj => { return { id: base64url.toBuffer(obj.id), type: obj.type } })
    const publicKey = {
        challenge: Uint8Array.from(challenge, c => c.charCodeAt(0)),
        allowCredentials: allowedCred,
        userVerification: "discouraged",
        timeout: 60000
    };

    navigator.credentials.get({
        "publicKey": publicKey
    }).then((pubKeyCredCaptured) => {
        var jsonPubKeyCred = Utils.publicKeyCredentialToJSON(pubKeyCredCaptured);
        appState.userCredentialsCaptured = btoa(JSON.stringify(jsonPubKeyCred));
        LoginStore.emitUserCredentialsCapture();
    });
}

LoginStore.updateUserAuthnMethod = function (idToken, userId, userType, remarks, authnMethod, traceId) {
    const udpateUserAuthnMethodUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.UPDATE_USER_AUTHN_METHOD_URL);
    console.log("Update User authn method : " + udpateUserAuthnMethodUrl);
    const updateAuthnMethodPayload = JSON.stringify({
        "remarks": remarks,
        "authenticationMethod": authnMethod
    });
    $.ajax({
        url: udpateUserAuthnMethodUrl + "/" + userId + "/" + userType + "/authentication-method",
        headers: {
            'Content-Type': 'application/json',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': 'Bearer ' + idToken,
            'Csrf-Token': 'nocheck'
        },
        type: 'PUT',
        data: updateAuthnMethodPayload,
        success: function (result, status, xhr) {
            console.log("Update AuthnMethod response status: " + status);
            console.log("update AuthnMethod response result: ", result);
            let saveStatus = result.status ? result.status : '';
            if (saveStatus === 200 || saveStatus === 201) {
                appState.updateAuthnMethodError = false;
                appState.authenticationMethod = authnMethod;
            } else {
                appState.updateAuthnMethodError = true;
            }
            if (authnMethod === AppConstants.TWO_FA_WEB_AUTHN) {
                LoginStore.emitSave2FAWebAuthn();
            }
            return;
        },
        error: function (xhr, status, err) {
            console.log("Failed to update user authn method: ", err);
            appState.updateAuthnMethodError = true;
            if (authnMethod === AppConstants.TWO_FA_WEB_AUTHN) {
                LoginStore.emitSave2FAWebAuthn();
            }
        }
    });
}

LoginStore.addUserAuthnMethod = function (idToken, userId, userType, remarks, authenticationMethod, traceId, name, mfaOption, authDetails) {
    const udpateUserAuthnMethodUrl = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.UPDATE_USER_AUTHN_METHOD_URL);
    console.log("Update User authn method : " + udpateUserAuthnMethodUrl);
    const updateAuthnMethodPayload = JSON.stringify({
        remarks,
        authenticationMethod,
        name,
        mfaOption,
        [`${mfaOption}Details`]: authDetails
    });
    $.ajax({
        url: udpateUserAuthnMethodUrl + "/" + userId + "/" + userType + "/auth-methods",
        headers: {
            'Content-Type': 'application/json',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': `Bearer ${idToken}`,
            'Csrf-Token': 'nocheck'
        },
        type: 'POST',
        data: updateAuthnMethodPayload,
        success: function (result, status, xhr) {
            console.log("Update AuthnMethod response status: " + status);
            console.log("update AuthnMethod response result: ", result);
            let saveStatus = result.status ? result.status : '';
            if (saveStatus === 200 || saveStatus === 201) {
                appState.updateAuthnMethodError = false;
                appState.authenticationMethod = authenticationMethod;
            } else {
                appState.updateAuthnMethodError = true;
            }
            if (authenticationMethod === AppConstants.TWO_FA_WEB_AUTHN) {
                LoginStore.emitSave2FAWebAuthn();
            }
            return;
        },
        error: function (xhr, status, err) {
            console.log("Failed to update user authn method: ", err);
            appState.updateAuthnMethodError = true;
            if (authenticationMethod === AppConstants.TWO_FA_WEB_AUTHN) {
                LoginStore.emitSave2FAWebAuthn();
            }
        }
    });
}

LoginStore.changeUserMFAMethod = function (idToken, userId, userType, credentialId, payload, countryCode) {
    const changeUserMFAMethodUrlPath = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.UPDATE_USER_AUTHN_METHOD_URL);
    $.ajax({
        url: `${changeUserMFAMethodUrlPath}/${userId}/${userType}/auth-methods/${credentialId}`,
        headers: {
            'Content-Type': 'application/json',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': 'Bearer ' + idToken,
            'Csrf-Token': 'nocheck'
        },
        type: 'PUT',
        data: JSON.stringify(payload),
        success: function (result, status, xhr) {
            console.log("change userMFAMethod response status: " + status);
            console.log("change userMFAMethod response result: " + result);

            let saveStatus = result.status ? result.status : '';
            if (saveStatus === 200) {
                appState.editAuthMethod = {
                    editAuthMethodError: false,
                    editAuthMethodCredentialId: credentialId
                }
                LoginStore.getUserMFAMethods(idToken, countryCode);
            }
            else {
                console.log(result.results[0][0].errorMessage, 'msg')
                appState.editAuthMethod = {
                    editAuthMethodError: true,
                    editAuthErrorMessage: result.results[0][0].errorMessage
                }
            }

            LoginStore.emitChangeUserMFAMethod()
            return;
        },
        error: function (xhr, status, err) {
            console.log("Failed to edit user auth method: " + err);

            if (status === 401 || status === 403) {
                Utils.logoutRedirect()
            };

            appState.editAuthMethod = {
                editAuthMethodError: true,
                editAuthErrorMessage: xhr.responseJSON.results[0][0].errorMessage
            };
            LoginStore.emitChangeUserMFAMethod();
        }
    });
}

LoginStore.deleteUserMFAMethod = function (idToken, userId, userType, credentialId, countryCode) {
    const deleteUserMFAMethodUrlPath = Utils.getUrlFromEnvUrls(window.WebConstants.envUrls.UPDATE_USER_AUTHN_METHOD_URL);
    $.ajax({
        url: `${deleteUserMFAMethodUrlPath}/${userId}/${userType}/auth-methods/${credentialId}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Expires': '0',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Authorization': 'Bearer ' + idToken,
            'Csrf-Token': 'nocheck'
        },
        type: 'delete',
        success: function (result, status, xhr) {
            console.log("delete userMFAMethod response status: " + status);
            console.log("delete userMFAMethod response result: " + result);

            appState.deleteUserMFA = {
                userMFAMethodId: credentialId,
                userMFAMethodError: false,
            };

            LoginStore.emitDeleteUserMFAMethod();
            LoginStore.getUserMFAMethods(idToken, countryCode);
            return;
        },
        error: function (xhr, status, err) {
            if (status === 401 || status === 403) {
                Utils.logoutRedirect()
            };

            console.log("Failed to delete user auth method: ", err);
            appState.deleteUserMFA = {
                userMFAMethodId: '',
                userMFAMethodError: true,
                userMFAMethodErrorMessage: xhr.responseJSON.results[0][0].errorMessage
            };

            LoginStore.emitDeleteUserMFAMethod();
        }
    });
}

LoginStore.getCaptchaConfig = (clientId, realmId, callback) => {
    const { url, method } = jsRoutes.controllers.web.ConfigurationParameterController.getCaptchaConfig(clientId, realmId);
    $.ajax({
        url,
        method,
        type: 'get',
        success: function (result, status, xhr) {
            callback(result);
            appState.captchaSettings = result;
        },
        error: function (xhr, status, err) {
            appState.captchaSettings = {
                enabled: false,
                siteKey: ''
            }
        }
    });
}

LoginStore.linkHospitalityDigitalAccount = (userId, password, externalId, sourceSystem) => {
    const linkAccountUrl = '/authenticate/link_account';
    $.ajax({
        headers: {
            'Csrf-Token': 'nocheck'
        },
        type: 'post',
        url: linkAccountUrl,
        data: {
            password,
            login_id: userId,
            external_id: externalId,
            source_system: sourceSystem
        },
        success: function (result, status, xhr) {
            appState.linkAccount = {
                error: false,
                responseCode: xhr.status
            };
            LoginStore.emitLinkHDAccount();
        },
        error: function (xhr, status, err) {
            appState.linkAccount = {
                error: true,
                responseCode: xhr.status
            };
            LoginStore.emitLinkHDAccount();
        }
    });
}

LoginStore.consentHospitalityDigital = (loginId, userType, clientId, countryCode, consent, consentCode) => {
    const consentAccountUrl = '/web/authc/consent';
    $.ajax({
        type: 'post',
        url: consentAccountUrl,
        data: {
            user_type: userType,
            login_id: loginId,
            client_id: clientId,
            country_code: countryCode,
            consent,
            consent_code: consentCode,
        },
        success: function (result, status, xhr) {
            appState.consent = {
                error: false,
                responseCode: xhr.status,
                result: result
            };
            LoginStore.emitConsetHD();
        },
        error: function (xhr, status, err) {
            appState.consent = {
                error: true,
                responseCode: xhr.status
            };
            LoginStore.emitConsetHD();
        }
    });
}

LoginStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case ActionTypes.SUBMIT_LOGIN:
            LoginStore.checkAuthentication(action.userId, action.password, action.userType,
                action.clientId, action.responseType, action.countryCode, action.localeId, action.realmId,
                action.accountId, action.redirectUrl, action.state, action.prompt, action.nonce, action.scope, action.traceId,
                action.codeChallenge, action.codeChallengeMethod, action.captchaToken);
            break;
        case ActionTypes.SUBMIT_LOGIN_WITH_PASSCODE:
            LoginStore.checkAuthenticationWithPasscode(action.userId, action.password, action.oneTimePasscode, action.userType,
                action.clientId, action.responseType, action.countryCode, action.localeId, action.realmId,
                action.accountId, action.redirectUrl, action.state, action.nonce, action.scope, action.traceId,
                action.codeChallenge, action.codeChallengeMethod);
            break;
        case ActionTypes.SUBMIT_SAML_LOGIN:
            LoginStore.checkSamlAuthentication(action.userId, action.password, action.userType,
                action.clientId, action.countryCode, action.localeId, action.realmId, action.traceId);
            break;
        case ActionTypes.VALIDATE_TOTP:
            LoginStore.validateTOTP(action.totp, action.idToken, action.userId,
                action.countryCode, action.realmId, action.userType, action.traceId);
            break;
        case ActionTypes.VALIDATE_TOTP_WITH_SESSION:
            LoginStore.validateTOTPWithSession(action.totp, action.idToken, action.userId,
                action.countryCode, action.realmId, action.userType, action.traceId, action.startSessionIdentifier, action.totpType, action.totpName);
            break;
        case ActionTypes.VALIDATE_AUTHENTICATOR_WITH_SESSION:
            LoginStore.validateAuthenticatorWithSession(action.authenticatorResponse, action.idToken, action.userId,
                action.countryCode, action.realmId, action.userType, action.traceId, action.startSessionIdentifier);
            break;
        case ActionTypes.VALIDATE_AUTHENTICATOR_WITH_INIT_ID:
            LoginStore.validateAuthenticatorWithInitId(action.authenticatorResponse, action.initSessionId,
                action.loginId, action.traceId);
            break;
        case ActionTypes.VALIDATE_TOTP_FORGOT_PASSWORD:
            LoginStore.validateTOTPForgotPassword(action.totp, action.idToken, action.userId,
                action.countryCode, action.realmId, action.userType, action.traceId);
            break;
        case ActionTypes.SUBMIT_FORGOT_PASSWORD:
            LoginStore.forgotPassword(action.userId, action.urlDetails, action.notificationChannel);
            break;
        case ActionTypes.SUBMIT_CHANGE_PASSWORD:
            LoginStore.changePassword(action.loginId, action.currentPassword, action.newPassword,
                action.userType, action.traceId);
            break;
        case ActionTypes.SUBMIT_RESET_PASSWORD:
            LoginStore.resetPassword(action.password, action.urlDetails);
            break;
        case ActionTypes.SUBMIT_LINK_HD_ACCOUNT:
            LoginStore.linkHospitalityDigitalAccount(action.userId, action.password, action.externalId, action.sourceSystem);
            break;
        case ActionTypes.SUBMIT_CONSENT_HD:
            LoginStore.consentHospitalityDigital(action.loginId, action.userType, action.clientId, action.countryCode, action.consent, action.consentCode);
            break;
        case ActionTypes.GET_WEB_CONFIGURATIONS:
            LoginStore.getWebPageConfigurations(action.props, action.localeId);
            break;
        case ActionTypes.GET_SUPPORTED_LOCALES:
            LoginStore.getSupportedLocales(action.realmId, action.countryCode, action.localeId);
            break;
        case ActionTypes.DISPLAY_TOAST:
            LoginStore.displayToast(action.toastMessage, action.toastType, action.clearToast, action.title);
            break;
        case ActionTypes.RESEND_TOTP:
            LoginStore.resendTOTP(action.loginId, action.traceId, action.idToken, action.realmId, action.countryCode, action.userType, action.totpType, action.totpName, action.userRequested);
            break;
        case ActionTypes.GENERATE_AND_SEND_OTP_USING_TEMP_SECRET:
            LoginStore.genAndSendOtpUsingTempSecret(action.userType, action.idToken, action.mobileNumber, action.countryCode, action.traceId, action.resendFlag);
            break;
        case ActionTypes.GET_TRANSLATIONS:
            LoginStore.getTranslations(action.countryCode, action.localeId);
            break;
        case ActionTypes.GET_USER_LOGIN_STRATEGY:
            LoginStore.getUserLoginStrategy(action.countryCode, action.userType);
            break;
        case ActionTypes.GET_MFA_OPTIONS:
            LoginStore.getMFAOptions(action.userType, action.countryCode);
            break;
        case ActionTypes.GET_PASSWORDLESS_METHODS:
            LoginStore.getPasswordlessMethods(action.clientId, action.loginId, action.userType );
            break;
        case ActionTypes.GET_PASSWORDLESS_INFO:
            LoginStore.getPasswordlessInfo(action.loginId, action.userType );
            break;
        case ActionTypes.SET_IS_INTRANET_REQUESTV2:
            LoginStore.setIsIntranetRequestV2();
            break;
        case ActionTypes.VALIDATE_OTP_AUTH:
            LoginStore.validateOtpAuth(action.loginId, action.userType, action.otp, action.countryCode, action.fwd_client_id );
            break;
        case ActionTypes.GENERATE_OTP_CODE:
            LoginStore.generateOtpCode(action.userId, action.isClientPasswordless, action.userType,
                action.clientId, action.responseType, action.countryCode, action.localeId, action.realmId,
                action.accountId, action.redirectUrl, action.state, action.prompt, action.nonce, action.scope, action.traceId,
                action.codeChallenge, action.codeChallengeMethod);
            break;
        case ActionTypes.GET_ALLOR_X_590_LOGIN:
            LoginStore.allowX509Login(action.clientId)
            break;
        case ActionTypes.GET_TWO_FA_TEMP_SECRET:
            LoginStore.getTwoFATempSecret(action.idToken, action.userType, action.traceId);
            break;
        case ActionTypes.GET_USER_DETAILS:
            LoginStore.getUserDetails(action.idToken, action.userType, action.traceId);
            break;
        case ActionTypes.VALIDATE_TOTP_APP_CODE:
            LoginStore.validateTOTPAppCode(action.idToken, action.userType, action.realmId, action.countryCode, action.traceId, action.code, action.mobileNumber)
            break;
        case ActionTypes.VALIDATE_ADD_TOTP_APP_CODE:
            LoginStore.validateAddTOTPAppCode(action.idToken, action.userType, action.realmId, action.countryCode, action.traceId, action.code, action.mobileNumber, action.localeId, action.method, action.name)
            break;
        case ActionTypes.CREATE_WEBAUTHN_CREDENTIALS:
            LoginStore.createWebauthnCredentials(action.idToken, action.challenge, action.userId, action.email, action.traceId, action.startSessionIdentifier)
            break;
        case ActionTypes.CAPTURE_WEBAUTHN_CREDENTIALS:
            LoginStore.captureWebauthnCredentials(action.challenge, action.allowedCredList)
            break;
        case ActionTypes.SAVE_2FA_CRED:
            LoginStore.save2faCred(action.idToken, action.userCred, action.userId, action.deviceName, action.traceId)
            break;
        case ActionTypes.GET_WEBAUTHN_CREDENTIALS:
            LoginStore.get2faWebAuthnCredentials(action.idToken, action.userId, action.traceId)
            break;
        case ActionTypes.GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN:
            LoginStore.get2faWebAuthnCredentialsForLogin(action.idToken, action.userId, action.traceId)
            break;
        case ActionTypes.GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN_1FA:
            LoginStore.get1faWebAuthnCredentialsForLogin(action.loginId, action.userType, action.clientId, action.realmId, action.initSessionId, action.traceId)
            break;
        case ActionTypes.DELETE_WEBAUTHN_CREDENTIALS:
            LoginStore.delete2faWebAuthnCredentials(action.idToken, action.deviceName, action.credentialId, action.userId, action.traceId)
            break;
        case ActionTypes.GET_USER_MFA_METHODS:
            LoginStore.getUserMFAMethods(action.idToken, action.countryCode);
            break;
        case ActionTypes.CHANGE_USER_MFA_METHOD:
            LoginStore.changeUserMFAMethod(action.idToken, action.userId, action.userType, action.credentialId, action.payload, action.countryCode)
            break;
        case ActionTypes.DELETE_USER_MFA_METHOD:
            LoginStore.deleteUserMFAMethod(action.idToken, action.userId, action.userType, action.credentialId, action.countryCode);
            break;
        default:
            return;
    }
});

module.exports = LoginStore;
